import { defineLocalStore } from '@/utils/localStore'
import { computed } from 'vue'
import type { UserAbsenceItem, VacationRow } from '@/utils/types/user'

export const {
  useLocalStore: useUserCardVacationsStore,
  initLocalStore: initUserCardVacationsStore,
} = defineLocalStore('userCardVacations', (core: any) => {
  const vacationRows = computed<VacationRow[]>(() => {
    if (Array.isArray(core.user.absences) && core.user.absences.length) {
      return core.user.absences.map((item: UserAbsenceItem, index: number) => ({
        id: item.id || index + 1,
        type: item.type?.name || 'Основна щорічна',
        startDate: item.startDate,
        endDate: item.endDate,
        days: item.days || item.dayCount || 5,
        deputy:
          item.deputy?.surname && item.deputy?.name
            ? `${item.deputy.surname} ${item.deputy.name}`
            : 'Не вказано',
        status: item.status?.name || 'Погоджена',
      }))
    }

    return [
      {
        id: 1,
        type: 'Основна щорічна',
        startDate: '15.07.2026',
        endDate: '05.08.2026',
        days: 22,
        deputy: 'Германчук Д.Д.',
        status: 'Запланована',
        statusColor: 'blue-lighten-5',
      },
      {
        id: 2,
        type: 'Основна щорічна',
        startDate: '22.12.2025',
        endDate: '29.12.2025',
        days: 8,
        deputy: 'Мазуренко А.В.',
        status: 'Завершена',
        statusColor: 'grey-lighten-3',
      },
      {
        id: 3,
        type: 'Навчальна',
        startDate: '10.06.2025',
        endDate: '14.06.2025',
        days: 5,
        deputy: 'Стеблевський Р.О.',
        status: 'Завершена',
        statusColor: 'grey-lighten-3',
      },
      {
        id: 4,
        type: 'За власний рахунок',
        startDate: '01.09.2026',
        endDate: '03.09.2026',
        days: 3,
        deputy: 'Германчук Д.Д.',
        status: 'Погоджена',
        statusColor: 'green-lighten-5',
      },
    ]
  })

  const vacationStats = computed(() => {
    const used = vacationRows.value.reduce(
      (sum, item) => sum + Number(item.days || 0),
      0
    )
    const total = Number(core.dialog?.dialogData?.vacationTotal || 28)

    return {
      total,
      used,
      available: total - used,
    }
  })

  return {
    vacationRows,
    vacationStats,
  }
})
